import { RealTimeAction } from '@/_core/fluxstore/types';
import { StorymapState } from '../types';
import { getCardById } from '../use';
import { useStorymapStore } from '../useModule';

const { registerReducer } = useStorymapStore();

export class UpdateCardWatchStatus extends RealTimeAction<StorymapState> {
    public static ACTION_TYPE = 'UpdateCardWatchStatus';

    public constructor(public cardId: string, public isWatched: boolean) {
        super(UpdateCardWatchStatus.ACTION_TYPE);
    }
}

const reducer = (state: StorymapState, action: UpdateCardWatchStatus): void => {
    const card = getCardById(action.cardId);

    if (card) {
        card.isWatched = action.isWatched;
    }
};

//@ts-ignore
registerReducer(UpdateCardWatchStatus.ACTION_TYPE, reducer);
